import React, { useState } from 'react';
import { connect } from 'react-redux';
import { EaseModal } from '../../../libs/EaseModal';
import { PayoutLinkForm } from '../Forms';
import { Text1, Text4 } from '../../../styles';
import { alertify, handleApiExceptions } from '../../../app_methods';
import { PayoutLink } from '../../../models';


const payoutLink = new PayoutLink();

const PayoutLinkModalComponent = (props) => {
    const [isLoading, setIsLoading] = useState(false);

    const createPayoutLink = async () => {
        setIsLoading(true);
        const response = await payoutLink.save();
        if (!response.success) {
            setIsLoading(false);
            handleApiExceptions(response);
            return;
        }
        alertify("Success", <>Payout link created successfully.<br /><Text4 copyable>{response.data.payout_link.link}</Text4></>, "success");
        props.toggleModal();
        setIsLoading(false);
        props.onSuccess();
    };

    return (
        <EaseModal
            width={550}
            title={false}
            visible={props.visible}
            onCancel={props.toggleModal}
            centered
            hideFooter
            destroyOnClose
        >
            <Text1 className="d-block mb-4" strong>Create Payout Link</Text1>
            <PayoutLinkForm
                onSubmit={(values) => {
                    payoutLink.set(values);
                    createPayoutLink();
                }}
                loading={isLoading}
            />
        </EaseModal>
    )
};

const mapStateToProps = state => ({
    current_user: state.userReducer.current_user
})

const PayoutLinkModal = connect(mapStateToProps, null)(PayoutLinkModalComponent);

export { PayoutLinkModal };